import React, { useMemo } from 'react';
import { GenericListPage } from '../../../components/generic';
import { useSpareCases, SpareCase } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  const config = useMemo(
    () => ({
      ...moduleConfig,
      getColumns,
      getToolbarIcon,
      getTableActions,
    }),
    [],
  );

  return <GenericListPage<SpareCase> useData={useSpareCases} config={config} />;
};

export default List;
